import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 20);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <span className="text-xl font-heading font-bold text-foreground-900 whitespace-nowrap">
            人渣游戏
          </span>
          <span className="hidden sm:inline text-xs text-foreground-600 whitespace-nowrap">
            深度解析
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors duration-200 cursor-pointer ${
              location.pathname === '/about'
                ? 'bg-primary-100 text-primary-700 font-medium'
                : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl text-foreground-800`} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 py-3 flex flex-col gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2.5 rounded-lg text-sm whitespace-nowrap transition-colors ${
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-3 py-2.5 rounded-lg text-sm whitespace-nowrap transition-colors ${
              location.pathname === '/about'
                ? 'bg-primary-100 text-primary-700 font-medium'
                : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}